import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import httpHelper, { Method_TYPE } from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import DataTable from 'react-data-table-component';
import Select from '../../../components/ui/Select';
import GroupLeaderModal from './GroupLeaderModal';

const GroupLeadersPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataTableData, setDataTableValue] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  useEffect(() => {
    getGroupLeaderDeatils();
  }, []);

  const getGroupLeaderDeatils = async () => {
    try {
      const data = await httpHelper(URL_CONSTANTS.GET_GROUP_LEADER_INFO, Method_TYPE.GET);
      console.log("Group leader data:", data);

      const formattedTableData = data?.map((group, index) => ({
        slno: index + 1,
        id: group?._id,
        batch: {
          batchName: group?.batch?.name,
          batchId: group?.batch?._id,
        },
        sector: {
          sectorName: group?.sector?.name,
          sectorId: group?.sector?._id,
        },
        leader1: {
          leader1Name: group?.leader1?.name,
          leader1Id: group?.leader1?._id,
          samithi: group?.leader1?.samithi,
          mobile: group?.leader1?.mobNoPrimary,
        },
        leader2: {
          leader2Name: group?.leader2?.name,
          leader2Id: group?.leader2?._id,
          samithi: group?.leader2?.samithi,
          mobile: group?.leader2?.mobNoPrimary,
        },
      }));

      console.log("Formatted table data:", formattedTableData);
      setDataTableValue(formattedTableData || []);
      setOriginalData(formattedTableData || []);
    } catch (err) {
      console.error('Error fetching group leader details:', err);
    }
  };

  const handleAddNew = () => {
    setSelectedPoint(null);
    setIsModalOpen(true);
  };

  const handleEdit = (row) => {
   let editValue = originalData?.filter(detail=> detail?.id === row)
  setSelectedPoint(editValue);
    setIsModalOpen(true);
  };

  const columns = [
    {
      name: 'Sl.No',
      selector: row => row.slno,
      sortable: true,
      cell: row => <div data-title="Sl.No">{row.slno}</div>,
    },
    {
      name: 'Sector',
      selector: row => row.sector?.sectorName,
      sortable: true,
      cell: row => <div data-title="Sector">{row.sector?.sectorName}</div>,
    },
    {
      name: 'Leader1',
      selector: row => row?.leader1?.leader1Name,
      sortable: true,
      cell: row => <div data-title="Leader1">{row?.leader1?.leader1Name}</div>,
    },
    {
      name: 'Leader2',
      selector: row => row?.leader2?.leader2Name,
      sortable: true,
      cell: row => <div data-title="Leader2">{row?.leader2?.leader2Name? row?.leader2?.leader2Name : "---"}</div>,
    },
    {
      name: 'Actions',
      cell: row => (
        <div data-title="Actions">
          <Button
            variant="ghost"
            size="sm"
            iconSize="16"
            onClick={() => handleEdit(row.id)}
            iconName="Edit"
            iconPosition="left"
          >
            <span className='inline-block lg:inline-block'>Edit</span>
          </Button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  return (
    <>
      <div className="p-4 text-center border-border bg-white bg-card border !rounded-lg shadow-spiritual-sm border-b-0 !rounded-bl-none !rounded-br-none relative">
        <div className="flex justify-between mb-0 md:flex-row flex-col">
          <div></div>
          <div className='flex mt-2 md:mt-0 justify-end'>
            <button
              type='button'
              className='inline-flex md:h-full mr-4 w-36 items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-gray-500 hover:text-white text-white rounded-md bg-gray-400 px-3'
              onClick={getGroupLeaderDeatils}
            >
              Refresh
            </button>
            <button
              type='button'
              className='hover:text-accent-foreground w-36 max-w-32 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-accent h-10 px-4 py-2'
              onClick={handleAddNew}
            >
              Add
            </button>
          </div>
        </div>
      </div>
        <DataTable
          columns={columns}
          data={dataTableData}
          fixedHeader
          fixedHeaderScrollHeight="500px"
          defaultSortFieldId={1}
          className="reports-table"
        />
        <GroupLeaderModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedPoint={selectedPoint}
        getGroupLeaderDeatils={getGroupLeaderDeatils}
        existingGroupLeaders={dataTableData}
      />
    </>
  );
};

export default GroupLeadersPage;
